import { Component, Inject, OnInit, viewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { WhitelabelService } from '../../services/whitelabel.service';
import AzureService from 'src/app/shared/services/azure.service';
import { environment } from 'src/environments/environment';
import { AzureBlobUploadPayload } from 'src/app/shared/interfaces/azure/blob-upload.interface';
import { QRCodeComponent } from 'angularx-qrcode';

@Component({
  standalone: false,
  selector: 'app-whitelabel-qrcode-viewer',
  templateUrl: './whitelabel-qrcode-viewer.component.html',
  styleUrls: ['./whitelabel-qrcode-viewer.component.css']
})
export class WhitelabelQrcodeViewerComponent implements OnInit {

  public isValid = false;

  private readonly qrCodeImageReference = viewChild.required<QRCodeComponent>('qrCodeImage');

  constructor(@Inject(MAT_DIALOG_DATA) public data: { link: string }) { 
    try {
      this.isValid = !!(new URL(this.data.link));
    } catch { }
  }

  ngOnInit(): void {}

}
